module.exports = __webpack_public_path__ + "img/SD11X5.png";